// Assessment de Perfil Relacional — Pathways to Liberation
// 28 habilidades em 6 domínios + Q29 aberta
// Textos exatos conforme documento "Avaliação de Habilidades Relacionais" (Paula Pontvianne)

export const DOMAINS = {
  autoconsciencia: {
    label: 'Autoconsciência',
    itemIds: ['estar_presente', 'observar_sem_interpretar', 'reconhecer_emocoes', 'autoaceitacao'],
  },
  autorregulacao: {
    label: 'Autorregulação',
    itemIds: ['responsabilidade_emocional', 'consciencia_motivadores', 'padroes_reatividade', 'elaborar_perdas'],
  },
  expressao: {
    label: 'Expressão',
    itemIds: ['pedidos_abertura', 'autenticidade', 'paciencia_pausar', 'arrependimento_benefico'],
  },
  empatia: {
    label: 'Empatia',
    itemIds: ['empatia_genuina', 'imagem_inimigo', 'facilitando_conexao', 'receber_feedback'],
  },
  conflito: {
    label: 'Conflito',
    itemIds: ['reatividade_outros', 'flexibilidade_relacoes', 'transformar_conflito', 'gratidao'],
  },
  sistema: {
    label: 'Sistema',
    itemIds: [
      'poder_escolha', 'interdependencia', 'abertura_compassiva', 'vitalidade',
      'compartilhar_poder', 'transcender_papeis', 'responsabilidade_consciente', 'sistemas_sustentaveis',
    ],
  },
};

// Alias para compatibilidade
export const COMPETENCIES = DOMAINS;

export const assessmentItems = [

  // ── Q1 ───────────────────────────────────────────────────────────────────
  {
    id: 'estar_presente',
    domain: 'autoconsciencia',
    number: 1,
    label: 'Estar presente',
    subtitle: 'Estar ciente do que está acontecendo aqui e agora.',
    options: [
      { score: 1, text: 'Frequentemente me vejo preso ao passado ou preocupado com o futuro.' },
      { score: 2, text: 'Percebo que me perco com frequência em pensamentos ou reações emocionais, ainda que não saiba o que fazer com isso.' },
      { score: 3, text: 'Quando percebo que estou perdido em pensamentos, consigo retornar ao momento presente se me esforço.' },
      { score: 4, text: 'Sinto-me naturalmente conectado ao momento presente, sem esforço.' },
    ],
  },

  // ── Q2 ───────────────────────────────────────────────────────────────────
  {
    id: 'observar_sem_interpretar',
    domain: 'autoconsciencia',
    number: 2,
    label: 'Observar sem interpretar',
    subtitle: 'Notar nossas observações livres de interpretação.',
    options: [
      { score: 1, text: 'Considero o que penso, analiso e interpreto como verdades absolutas sem questioná-las.' },
      { score: 2, text: 'Noto que minhas interpretações nem sempre são fatos, e ainda assim com frequência confundo os dois.' },
      { score: 3, text: 'Sou capaz de distinguir observações de interpretações em situações do dia a dia.' },
      { score: 4, text: 'Separo de forma natural e consistente o que está de fato acontecendo e o que interpreto ou penso sobre eles.' },
    ],
  },

  // ── Q3 ───────────────────────────────────────────────────────────────────
  {
    id: 'reconhecer_emocoes',
    domain: 'autoconsciencia',
    number: 3,
    label: 'Reconhecer e nomear emoções',
    subtitle: 'Capacidade de identificar e vivenciar nossas sensações corporais e emoções.',
    options: [
      { score: 1, text: 'Tenho dificuldade em identificar qual emoção está ativa em cada situação e não conheço muitos nomes para minhas emoções como raiva, alegria e tristeza, por exemplo.' },
      { score: 2, text: 'Reconheço a importância das emoções em nossas vidas, mas não é fácil identificar e nomear o que estou sentindo.' },
      { score: 3, text: 'Sou capaz de reconhecer e nomear minhas emoções, ainda que precise de um esforço para aceitá-las.' },
      { score: 4, text: 'Aceito plenamente minhas emoções e as experimento sem resistência.' },
    ],
  },

  // ── Q4 ───────────────────────────────────────────────────────────────────
  {
    id: 'autoaceitacao',
    domain: 'autoconsciencia',
    number: 4,
    label: 'Autoaceitação',
    subtitle: 'Capacidade de se auto validar e legitimar.',
    options: [
      { score: 1, text: 'Me percebo como uma pessoa severa comigo mesma, frequentemente me julgo de forma negativa e dura.' },
      { score: 2, text: 'Percebo meus padrões severos de autojulgamento e entendo que poderia haver outras formas de me avaliar.' },
      { score: 3, text: 'Sou capaz de me observar com compaixão, ainda que precise de esforço para substituir o autojulgamento pela autoaceitação.' },
      { score: 4, text: 'Aceito minhas imperfeições com compaixão e sem julgamentos.' },
    ],
  },

  // ── Q5 ───────────────────────────────────────────────────────────────────
  {
    id: 'responsabilidade_emocional',
    domain: 'autorregulacao',
    number: 5,
    label: 'Auto responsabilização emocional',
    subtitle: 'Reconhecer que sou responsável pelo que sinto.',
    options: [
      { score: 1, text: 'Quando algo acontece que me deixa feliz, triste, com raiva, acredito que seja por causa das ações de outras pessoas.' },
      { score: 2, text: 'Noto que minhas emoções são minha responsabilidade, mas não sei como manejá-las.' },
      { score: 3, text: 'Reconheço que minhas emoções estão conectadas com minhas próprias necessidades, não com as ações alheias, ainda que precise de esforço prático para manejá-las.' },
      { score: 4, text: 'Consigo separar o que acontece fora e dentro de mim, sendo tranquilo manejar e regular o que sinto.' },
    ],
  },

  // ── Q6 ───────────────────────────────────────────────────────────────────
  {
    id: 'consciencia_motivadores',
    domain: 'autorregulacao',
    number: 6,
    label: 'Consciência das necessidades',
    subtitle: 'Habilidade de reconhecer os motivadores humanos, meus e de outras pessoas.',
    options: [
      { score: 1, text: 'Acredito que necessidades são desejos supérfluos, coisa de pessoas carentes.' },
      { score: 2, text: 'Compreendo que seres humanos são motivados a agir para atender necessidades humanas, mas não sei reconhecer e nomear quais são essas.' },
      { score: 3, text: 'Sou capaz de reconhecer e notar quais são as necessidades que estão por trás de cada ação, mas ainda tenho dificuldade de diferenciar a ação da necessidade.' },
      { score: 4, text: 'Reconheço e vivo em meu dia-a-dia a consciência de que tudo o que fazemos é uma tentativa (efetiva ou não) de sobreviver e prosperar.' },
    ],
  },

  // ── Q7 ───────────────────────────────────────────────────────────────────
  {
    id: 'padroes_reatividade',
    domain: 'autorregulacao',
    number: 7,
    label: 'Reconhecer padrões de reatividade e se recuperar',
    subtitle: '',
    options: [
      { score: 1, text: 'Me considero uma pessoa reativa, é comum reagir automaticamente às situações sem refletir antes de agir.' },
      { score: 2, text: 'Começo a perceber padrões de reatividade, mas ainda tenho dificuldade em evitá-los.' },
      { score: 3, text: 'Posso me reconectar comigo mesmo antes de reagir impulsivamente.' },
      { score: 4, text: 'Consigo manter a calma e responder conscientemente em situações desafiadoras.' },
    ],
  },

  // ── Q8 ───────────────────────────────────────────────────────────────────
  {
    id: 'pedidos_abertura',
    domain: 'expressao',
    number: 8,
    label: 'Fazer pedidos com abertura',
    subtitle: 'Disposição para pedir o que desejo, aberta a receber qualquer resposta.',
    options: [
      { score: 1, text: 'Tenho dificuldade em expressar claramente o que preciso e acredito que tem vezes que eu nem deveria pedir porque o outro deveria saber o que é preciso ser feito.' },
      { score: 2, text: 'Percebo a importância de fazer pedidos claros, mas me sinto desconfortável quando a pessoa nega meu pedido.' },
      { score: 3, text: 'Consigo fazer pedidos de forma clara, sem exigir ou pressionar.' },
      { score: 4, text: 'Sou uma pessoa bem disposta a fazer pedidos claros e lido de maneira aberta e sem apego a respostas que possam vir, incluindo negativas.' },
    ],
  },

  // ── Q9 ───────────────────────────────────────────────────────────────────
  {
    id: 'elaborar_perdas',
    domain: 'autorregulacao',
    number: 9,
    label: 'Elaborar perdas',
    subtitle: 'Transformar o sofrimento da perda sem resistir a ele.',
    options: [
      { score: 1, text: 'Não dou atenção a sentimentos de derrota, passo por cima porque sei que não me afeto com nenhum tipo de perda.' },
      { score: 2, text: 'Percebo os impactos que perdas têm em mim e noto minha resistência em aceitar isso, mas não sei como processá-las.' },
      { score: 3, text: 'Consigo reconhecer e legitimar a tristeza da perda, ainda que tenha que me esforçar para não me deixar levar por sentimentos de culpa ou evitação ou por pensamentos de certo e errado.' },
      { score: 4, text: 'Experimento as perdas como parte natural da vida e consigo me abrir para as novas possibilidades que surgem a partir delas.' },
    ],
  },

  // ── Q10 ──────────────────────────────────────────────────────────────────
  {
    id: 'empatia_genuina',
    domain: 'empatia',
    number: 10,
    label: 'Oferecer empatia genuína',
    subtitle: 'Estar presente com a outra pessoa, com aceitação incondicional de sua experiência.',
    options: [
      { score: 1, text: 'Quando alguém está me contando algo eu costumo dar conselhos, e perguntar muitas coisas para sanar minha curiosidade. É comum ter que interromper a pessoa para perguntar ou já dizer o que penso.' },
      { score: 2, text: 'Percebo quando trago o foco para mim em vez de escutar até o fim, mas ainda não sei o que fazer para o outro notar que estou presente na conversa e me pego querendo dar conselhos e fazer perguntas.' },
      { score: 3, text: 'Consigo ouvir o outro com presença e refletir sua experiência sem incluir minha avaliação a respeito do que a pessoa disse.' },
      { score: 4, text: 'Escuto profundamente, oferecendo espaço e aceitação incondicional para o outro.' },
    ],
  },

  // ── Q11 ──────────────────────────────────────────────────────────────────
  {
    id: 'imagem_inimigo',
    domain: 'empatia',
    number: 11,
    label: 'Desconstruir imagens de inimigo',
    subtitle: '',
    options: [
      { score: 1, text: 'Acredito que há no mundo pessoas erradas ou más e acredito que devem ser punidas.' },
      { score: 2, text: 'Percebo a importância de escapar aos padrões de separação das coisas e pessoas entre o que é certo e o que é errado, mas ainda acho difícil mudá-los em mim.' },
      { score: 3, text: 'Quando realizo que estou entendendo que certas pessoas e grupos são meus inimigos, sou capaz de desafiar meus pensamentos de hostilidade e buscar ver a humanidade neles.' },
      { score: 4, text: 'Vejo a humanidade em todos, mesmo naqueles que me desafiam.' },
    ],
  },

  // ── Q12 ──────────────────────────────────────────────────────────────────
  {
    id: 'poder_escolha',
    domain: 'sistema',
    number: 12,
    label: 'Poder de escolha afinado ao bem-estar comum',
    subtitle: '',
    options: [
      { score: 1, text: 'A melhor forma de decidir ou escolher é pensar qual das opções é aquela que julgo certa e descartar o que julgo como errado.' },
      { score: 2, text: 'Reconheço formas de fazer escolhas e tomar decisões que não se pautam pela ideia de certo e errado, mas ainda acesso esses antigos padrões.' },
      { score: 3, text: 'Faço escolhas considerando o impacto para mim e para os outros.' },
      { score: 4, text: 'Escolho sempre aquilo que serve à vida, levando em conta o bem-estar de todos os envolvidos.' },
    ],
  },

  // ── Q13 ──────────────────────────────────────────────────────────────────
  {
    id: 'interdependencia',
    domain: 'sistema',
    number: 13,
    label: 'Vivendo de maneira interdependente',
    subtitle: '',
    options: [
      { score: 1, text: 'Acredito que é preciso me virar sozinho sem depender de ninguém.' },
      { score: 2, text: 'Percebo os impactos das minhas escolhas em outras pessoas e vejo o impacto das escolhas dos outros em minha vida, mas ainda é difícil de aceitar sem me ressentir, submeter ou forçar minha opção.' },
      { score: 3, text: 'Consigo equilibrar minhas necessidades com as dos outros, buscando soluções que beneficiem ambos.' },
      { score: 4, text: 'Me sinto mais potente e energizado quando vivencio a interdependência de forma fluida e harmoniosa.' },
    ],
  },

  // ── Q14 ──────────────────────────────────────────────────────────────────
  {
    id: 'autenticidade',
    domain: 'expressao',
    number: 14,
    label: 'Expressar-se com autenticidade',
    subtitle: '',
    options: [
      { score: 1, text: 'Falo o que é preciso falar, sem pensar muito nas palavras, deixo minhas emoções e pensamentos seguirem rumo ao outro sem filtro, principalmente quando tenho reclamações ou críticas.' },
      { score: 2, text: 'Quando me expresso percebo que acabo afastando as pessoas ao invés de aproximá-las, mesmo quando estou em sintonia com a ideia da outra pessoa.' },
      { score: 3, text: 'Consigo me expressar com honestidade, buscando conexão ao invés de confronto mesmo quando sinto estresse.' },
      { score: 4, text: 'Me comunico de forma autêntica e aberta, sem medo de me vulnerabilizar e mantendo espaço para a outra pessoa e suas necessidades.' },
    ],
  },

  // ── Q15 ──────────────────────────────────────────────────────────────────
  {
    id: 'facilitando_conexao',
    domain: 'empatia',
    number: 15,
    label: 'Facilitando conexão',
    subtitle: '',
    options: [
      { score: 1, text: 'Muitas vezes falo argumentando para convencer ou impor meu ponto de vista.' },
      { score: 2, text: 'Percebo quando o que falo gera mais desconexão do que conexão, ainda assim segue sendo meu padrão.' },
      { score: 3, text: 'Sou capaz de me expressar com firmeza na minha intenção de me conectar mesmo quando sinto estresse.' },
      { score: 4, text: 'Consigo me expressar de maneira vulnerável e respeitosa, além de apoiar que os outros façam isso também, facilitando diálogos em que todos se sintam vistos, ouvidos e compreendidos.' },
    ],
  },

  // ── Q16 ──────────────────────────────────────────────────────────────────
  {
    id: 'paciencia_pausar',
    domain: 'expressao',
    number: 16,
    label: 'Paciência — pausar quando necessário',
    subtitle: '',
    options: [
      { score: 1, text: 'Quando alguém perto de mim está estressado, eu absorvo a tensão e reajo no automático (ataco, justifico ou fujo) sem perceber o que sinto.' },
      { score: 2, text: 'Já noto alguns sinais no meu corpo e tento pausar, mas ainda respondo defensivamente com frequência e só depois percebo que fui no impulso.' },
      { score: 3, text: 'Costumo fazer uma pausa, respirar e nomear o que sinto; na maioria das vezes escolho como responder, embora às vezes ainda escorregue.' },
      { score: 4, text: 'Consigo sustentar minha presença com serenidade: sinto minhas reações sem agir a partir delas, escuto o outro e coloco limites com clareza quando preciso.' },
    ],
  },

  // ── Q17 ──────────────────────────────────────────────────────────────────
  {
    id: 'reatividade_outros',
    domain: 'conflito',
    number: 17,
    label: 'Respondendo à reatividade de outros',
    subtitle: '',
    options: [
      { score: 1, text: 'Reajo impulsivamente quando alguém está emocionalmente engatilhado — bateu, levou!' },
      { score: 2, text: 'Percebo que quando reajo à reatividade do outro dificulto conexão entre nós, mas ainda me deixo levar.' },
      { score: 3, text: 'Me abro com curiosidade para a perspectiva da outra pessoa, mesmo diante de formas agressivas de comunicação dela, consigo escolher entre empatia ou honestidade.' },
      { score: 4, text: 'Consigo me manter com qualidade de presença e aceitar que a outra pessoa está engatilhada buscando oferecer empatia diante da reatividade do outro.' },
    ],
  },

  // ── Q18 ──────────────────────────────────────────────────────────────────
  {
    id: 'receber_feedback',
    domain: 'empatia',
    number: 18,
    label: 'Abertura ao feedback',
    subtitle: '',
    options: [
      { score: 1, text: 'Pra mim feedback é uma crítica ou enaltecimento, como se houvesse algo de errado comigo. Fico na defensiva.' },
      { score: 2, text: 'Percebo que há algo no feedback que possa servir de aprendizado, mas ainda respondo com reatividade.' },
      { score: 3, text: 'Compreendo que o feedback de outra pessoa é a perspectiva dela a partir de suas próprias necessidades; e vejo que minhas reações ao feedback têm a ver com as minhas próprias necessidades.' },
      { score: 4, text: 'Recebo feedbacks com clareza de escolha, reconhecendo e validando a perspectiva da outra pessoa e escolhendo aprender e ter discernimento diante dela.' },
    ],
  },

  // ── Q19 ──────────────────────────────────────────────────────────────────
  {
    id: 'arrependimento_benefico',
    domain: 'expressao',
    number: 19,
    label: 'Arrependimento benéfico',
    subtitle: '',
    options: [
      { score: 1, text: 'Sinto culpa e vergonha quando percebo que causei impacto negativo.' },
      { score: 2, text: 'Começo a entender que posso aprender com meus erros sem me punir.' },
      { score: 3, text: 'Busco corrigir ações sem me afundar na culpa.' },
      { score: 4, text: 'Transformo o arrependimento em aprendizado e crescimento.' },
    ],
  },

  // ── Q20 ──────────────────────────────────────────────────────────────────
  {
    id: 'flexibilidade_relacoes',
    domain: 'conflito',
    number: 20,
    label: 'Flexibilidade nas relações',
    subtitle: '',
    options: [
      { score: 1, text: 'Para que eu possa ter sucesso é preciso que eu vença; infelizmente quando eu venço o outro perde e a vida é assim.' },
      { score: 2, text: 'Compreendo que além do certo e errado há outras possibilidades para relacionar-se, ainda que meus padrões de reatividade sempre apareçam. Estruturo minhas falas no passo a passo da CNV.' },
      { score: 3, text: 'Sou capaz de ouvir e entender para além da ação das pessoas; a escuta atenta e ativa me permite acessar compreensão mesmo que não concorde com a pessoa.' },
      { score: 4, text: 'Tenho abertura e flexibilidade em minhas relações. Minha expressão é autêntica e legitimo a autenticidade da expressão de outras pessoas com naturalidade.' },
    ],
  },

  // ── Q21 ──────────────────────────────────────────────────────────────────
  {
    id: 'transformar_conflito',
    domain: 'conflito',
    number: 21,
    label: 'Transformando o conflito',
    subtitle: '',
    options: [
      { score: 1, text: 'Eu evito conflitos o máximo que posso, acho o conflito uma coisa ruim. Quando entro tendo a defender meu lado da história.' },
      { score: 2, text: 'Consigo perceber e nomear meus incômodos e ouvir os incômodos da pessoa em conflito comigo, mas conflitos são muito desconfortáveis para mim.' },
      { score: 3, text: 'Uso conflitos como oportunidades para compreender melhor a mim e aos outros, mesmo quando eu reajo de forma como não gostaria.' },
      { score: 4, text: 'Acolho os conflitos com abertura e curiosidade com relação às diferentes perspectivas, buscando soluções benéficas para todos e apoiando a todas pessoas envolvidas em sua transformação.' },
    ],
  },

  // ── Q22 ──────────────────────────────────────────────────────────────────
  {
    id: 'gratidao',
    domain: 'conflito',
    number: 22,
    label: 'Gratidão',
    subtitle: '',
    options: [
      { score: 1, text: 'Percebo mais o que está faltando, reclamo. Me percebo mais satisfeita quando recebo validação por meio de elogios e recompensas.' },
      { score: 2, text: 'Percebo o valor que tem em reconhecer necessidades atendidas, ainda tenho dificuldade em escapar ao padrão de elogiar no lugar de demonstrar gratidão.' },
      { score: 3, text: 'Consigo expressar gratidão reconhecendo necessidades atendidas em situações que me fazem bem.' },
      { score: 4, text: 'Sou capaz de me conectar com os valores que estão expressos em cada ação e manifesto minha apreciação cultivando aprendizado.' },
    ],
  },

  // ── Q23 ──────────────────────────────────────────────────────────────────
  {
    id: 'abertura_compassiva',
    domain: 'sistema',
    number: 23,
    label: 'Abertura compassiva — dar e receber',
    subtitle: 'Transformar o pensamento de escassez para prosperar de forma criativa.',
    options: [
      { score: 1, text: 'Geralmente digo "sim" para não desagradar e depois me sinto sobrecarregada; raramente peço o que preciso e, quando dou, sinto que perco algo.' },
      { score: 2, text: 'Já percebo minhas necessidades e às vezes peço, mas oscilo: ora dou demais e me arrependo, ora me fecho com medo de sair no prejuízo.' },
      { score: 3, text: 'Costumo dizer "sim" e "não" com clareza; peço o que preciso e dou por escolha. Às vezes ainda bate o medo de perder, mas eu converso sobre isso.' },
      { score: 4, text: 'Vivo o dar e receber como via de mão dupla: peço e ofereço com tranquilidade, confio na reciprocidade e dou sem sensação de perda, respeitando meus limites.' },
    ],
  },

  // ── Q24 ──────────────────────────────────────────────────────────────────
  {
    id: 'vitalidade',
    domain: 'sistema',
    number: 24,
    label: 'Resiliência e vitalidade',
    subtitle: '',
    options: [
      { score: 1, text: 'Minha cabeça não para, estou sempre com muitos pensamentos ativos e na maioria das vezes isso gera uma queda de energia.' },
      { score: 2, text: 'Noto quando meus pensamentos estão agitados e/ou flutuando, percebo quando minha energia está desgastando ou elevando, ainda que não consiga manejar isso.' },
      { score: 3, text: 'Frequentemente busco recursos internos para regular minha energia, qualidade de presença e vitalidade.' },
      { score: 4, text: 'Estou sintonizada comigo, equilibrando autocuidado e cultivo de energia para me manter a serviço da vida.' },
    ],
  },

  // ── Q25 ──────────────────────────────────────────────────────────────────
  {
    id: 'compartilhar_poder',
    domain: 'sistema',
    number: 25,
    label: 'Compartilhar poder com consciência e equidade',
    subtitle: '',
    options: [
      { score: 1, text: 'Apenas eu posso resolver as coisas como quero que sejam resolvidas, tenho dificuldade de delegar, de partilhar tomada de decisão e ao mesmo tempo entendo que meus superiores devem fazer o mesmo.' },
      { score: 2, text: 'Percebo valor em compartilhar poder, mas ainda não sei como efetivamente fazer isso.' },
      { score: 3, text: 'Busco colaboração e tomada de decisão compartilhada em minhas relações.' },
      { score: 4, text: 'Honro a autonomia de todos e valorizo a mutualidade em todas as minhas interações.' },
    ],
  },

  // ── Q26 ──────────────────────────────────────────────────────────────────
  {
    id: 'transcender_papeis',
    domain: 'sistema',
    number: 26,
    label: 'Transcendendo papéis',
    subtitle: '',
    options: [
      { score: 1, text: 'Acredito que o papel que desempenhamos na vida representa quem somos e vivo fortemente vinculada aos papeis que desempenho: mãe, professora, chefe, irmã...' },
      { score: 2, text: 'Percebo que há algo além dos papeis que representamos na vida.' },
      { score: 3, text: 'Tenho consciência de que os papeis são temporários e posso escolher como me relacionar com eles e com as outras pessoas além dos papéis que representam.' },
      { score: 4, text: 'Tenho consciência e sou capaz de me conectar com a humanidade em cada um para além dos papeis que desempenhamos.' },
    ],
  },

  // ── Q27 ──────────────────────────────────────────────────────────────────
  {
    id: 'responsabilidade_consciente',
    domain: 'sistema',
    number: 27,
    label: 'Responsabilidade consciente',
    subtitle: '',
    options: [
      { score: 1, text: 'Meu padrão de pensamento me leva sempre a buscar um culpado pela situação. Seja eu ou o outro, é importante identificar quem está errando e administrar essa culpa.' },
      { score: 2, text: 'Sinto alívio em reconhecer minha liberdade e poder, e ao mesmo tempo acredito que é preciso que culpados sejam corrigidos, eu ou o outro.' },
      { score: 3, text: 'Assumo responsabilidade pelos meus sentimentos e reações. Consigo separar o que é meu e o que é do outro e me responsabilizar pelo que é meu.' },
      { score: 4, text: 'Me aproprio da minha própria experiência e escolhas, lido com minhas dores sem culpar os outros e sem me apropriar das reações e respostas dos outros.' },
    ],
  },

  // ── Q28 ──────────────────────────────────────────────────────────────────
  {
    id: 'sistemas_sustentaveis',
    domain: 'sistema',
    number: 28,
    label: 'Contribuir para sistemas sustentáveis e humanos',
    subtitle: '',
    options: [
      { score: 1, text: 'Sinto que sou impotente para influenciar sistemas e estruturas maiores.' },
      { score: 2, text: 'Percebo que mudanças são possíveis, mas ainda não sei como contribuir para sistemas mais justos.' },
      { score: 3, text: 'Busco formas de promover bem-estar coletivo e impacto positivo nos sistemas em que atuo.' },
      { score: 4, text: 'Atuo de forma ativa na construção e evolução de sistemas mais sustentáveis e inclusivos com abertura ao feedback.' },
    ],
  },
];

// ── Labels ────────────────────────────────────────────────────────────────────
export const SKILL_LABELS = Object.fromEntries(
  assessmentItems.map(item => [item.id, item.label])
);

export const DOMAIN_LABELS = {
  autoconsciencia: 'Autoconsciência',
  autorregulacao:  'Autorregulação',
  expressao:       'Expressão',
  empatia:         'Empatia',
  conflito:        'Conflito',
  sistema:         'Sistema',
};

// Aliases legados
export const COMPETENCY_LABELS = DOMAIN_LABELS;
export const skillLabels = SKILL_LABELS;
export const ILHA_LABELS = {
  autogestao:  'Autogestão Emocional',
  comunicacao: 'Comunicação Interpessoal',
  conflitos:   'Gestão de Conflitos',
  ambientes:   'Ambientes Colaborativos',
};
